import cookie from '@/common/utils/cookie'
import {
  getGUID,
  getIp,
  getServiceLocationInfo,
  isSnsLogin,
  setDisableScrolling
} from '@/common/utils/common'
import store from '@/store'
import _ from 'lodash'
import { SHOW_LOGIN_POPUP } from '@/common/resources/store.type.const'
import { stringify } from 'query-string'
import { READY, UPDATE } from '@/common/resources/jarvis.event.const'
import {
  PLAYER_UPDATE_EVENT,
  SERVICE_LOCATION_AMAZON,
  SERVICE_LOCATION_AZURE,
  SERVICE_LOCATION_AZURE_FOR_PLAYER
} from '@/common/resources/const'
import constant from '@/common/resources/constant'

export const showDownloadLayoutWithContext = (context) => () => {
  if (cookie.hasNotCredential()) {
    store.commit(SHOW_LOGIN_POPUP)
  } else {
    context.downloadLayout = true
    setDisableScrolling(true)
  }
}

let voucherPopup = null
// let voucherPopupInterval = null

// function checkClosePopup () {
//   if (voucherPopup === null || voucherPopup.closed) {
//     clearInterval(voucherPopupInterval)
//     voucherPopup = null
//     voucherPopupInterval = null
//     // location.reload()
//   }
// }

export const showVoucherPopup = ({ type, contentInfo }) => {
  if (cookie.hasNotCredential()) {
    store.commit(SHOW_LOGIN_POPUP)
  } else {
    if (isSnsLogin()) {
      if (!confirm(constant.MSG_VOUCHER_SNS_ALERT)) { return }
    }
    const baseUrl = '/voucher/popup'
    const params = {}
    switch (type) {
      case 'vod':
      case 'voddownload':
        params.type = 'voucher'
        params.contenttype = 'vod'
        params.contentid = _.get(contentInfo, 'contentid', '')
        params.programid = _.get(contentInfo, 'programid', '')
        params.channelid = _.get(contentInfo, 'channelid', '')
        params.cpid = _.get(contentInfo, 'cpid', '')
        if (type === 'voddownload') {
          params.downloadyn = _.get(contentInfo, 'downloadable', 'n')
        }
        break
      case 'movie':
      case 'moviedownload':
        params.type = 'movie'
        params.contenttype = 'movie'
        params.contentid = _.get(contentInfo, 'movieid', '') || _.get(contentInfo, 'contentid', '')
        params.programid = _.get(contentInfo, 'movieid', '') || _.get(contentInfo, 'contentid', '')
        params.channelid = 'none'
        params.cpid = _.get(contentInfo, 'cpid', '')
        params.playy = _.indexOf(_.get(contentInfo, 'moviemarks', []), 'playy') > -1 ? 'y' : 'n'
        if (type === 'moviedownload') {
          params.downloadyn = _.get(contentInfo, 'downloadable', 'n')
        }
        break
      case 'live':
        params.type = 'voucher'
        params.contenttype = 'live'
        params.contentid = _.get(contentInfo, 'channelid', '')
        params.programid = _.get(contentInfo, 'programid', '')
        params.channelid = _.get(contentInfo, 'channelid', '')
        params.cpid = _.get(contentInfo, 'cpid', '')
        break
      case 'clip':
        params.type = 'all'
    }
    voucherPopup = window.open(`${baseUrl}?${stringify(params)}`, '', 'width=700, height=780, scrollbars=yes')
    voucherPopup.focus()
    // if (voucherPopup) {
    //   voucherPopupInterval = setInterval(checkClosePopup, 800)
    // }
  }
}

export const showVoucherPopupWithContext = ({ type, contentInfo }) => () => { showVoucherPopup({ type, contentInfo }) }

export const getPlayerDelegateInstance = (context) => {
  delete window.playerDelegate
  class PlayerDelegate {
    constructor (context) {
      this.context = context
    }
    onEvent (e, value) {
      switch (e) {
        case READY:
          // logger('cyan')('READY')
          this.context.playerInit()
          break
        case UPDATE:
          // logger('cyan')('UPDATE')
          // logger('cyan')(value.contentID)
          this.context.$events.$emit(PLAYER_UPDATE_EVENT, value)
          break
        default:
          break
      }
    }
  }
  window.playerDelegate = new PlayerDelegate(context)
  console.log('getPlayerDelegateInstance :: context : ', context)
  console.log('getPlayerDelegateInstance :: window.playerDelegate : ', window.playerDelegate)
  return window.playerDelegate
}

export const setPlayerModeDefault = () => {
  if (window.playerInstance) {
    window.playerInstance.setDefaultMode()
  }
}

export const playerDelegate = (context) => {
  let callbackTimer = setInterval(function () {
    delete window.playerInstance
    try {
      const serviceLocationInfo = getServiceLocationInfo()
      const apiLocation = _.get(serviceLocationInfo, 'location', SERVICE_LOCATION_AMAZON)
      window.playerInstance = new window.PlayerAdapt({
        forceHtml: false,
        cloudType: apiLocation === SERVICE_LOCATION_AZURE ? SERVICE_LOCATION_AZURE_FOR_PLAYER : SERVICE_LOCATION_AMAZON
      })
    } catch (e) {}
    if (window.playerInstance) {
      clearInterval(callbackTimer)
      let containerChecker = setInterval(function () {
        if (document.querySelector('#container')) {
          clearInterval(containerChecker)
          window.playerInstance.whenInit('container', getPlayerDelegateInstance(context))
          context = null
        }
      }, 300)
    }
  }, 100)
  // }
}

export const showLoginPopup = () => {
  store.commit(SHOW_LOGIN_POPUP)
}

export const getNoneCredentialUserInfo = () => {
  return {
    credentialKey: 'none',
    GUID: getGUID(),
    clientIP: getIp(),
    userNo: 'none',
    userID: 'none',
    profileID: 'none',
    pooqzoneType: cookie.getPooqZoneType()
  }
}
